module.exports = __webpack_public_path__ + "static/media/check-mark.2b937530.svg";